import React from 'react'

const StaffTab = () => {
  return (
    <div>StaffTab</div>
  )
}

export default StaffTab;
